import Vue from 'vue'
import Router from 'vue-router'
import vstrore from '../vuex/store';

Vue.use(Router)

let route = [{
    path: '/',
    name: 'index',
    component: () => import('@/pages/dumanbet/index.vue'),
    meta: {
      title: '主页'
    },
    children: [
      {
        path: '/',
        name: 'Home',
        component: () => import('@/pages/dumanbet/homePage.vue'),
        meta: {
          title: '首页'
        }
      },
      {
        path: '/profile',
        name: 'Profile',
        component: () => import('@/pages/profile'),
        meta: {
          title: '首页'
        }
      },
      {
        path: '/game',
        name: 'Game',
        component: () => import('@/pages/dumanbet/gamePage.vue'),
        meta: {
          title: '游戏'
        }
      },
      {
        path: '/video',
        name: 'Vidoe',
        component: () => import('@/pages/dumanbet/videoPage.vue'),
        meta: {
          title: '电子视讯'
        }
      },
      {
        path: '/login',
        name: 'Login',
        component: () => import('@/pages/dumanbet/loginPage.vue'),
        meta: {
          title: '登录'
        }
      },
      {
        path: '/searchGames',
        name: 'searchGames',
        component: () => import('@/pages/dumanbet/searchGames.vue'),        
        meta: {
          title: 'Search Games'
        }
      },

      {
        path: '/recharge',
        name: 'recharge',
        component: () => import('@/pages/recharge/rechargeIndex.vue'),        
        meta: {
          title: 'Recharge'
        }
      },
      {
        path: '/rechargeRecord',
        name: 'rechargeRecord',
        component: () => import('@/pages/recharge/rechargeRecord.vue'),        
        meta: {
          title: 'Recharge Record'
        }
      },
      {
        path: '/recharge-payment',
        name: 'Recharge Payment',
        component: () => import('@/pages/recharge/rechargePayment.vue'),        
        meta: {
          title: 'Recharge Payment'
        }
      },


      {
        path: '/withdraw',
        name: 'withdraw',
        component: () => import('@/pages/withdraw/withdrawalIndex.vue'),        
        meta: {
          title: 'Withdrawal'
        }
      },
      {
        path: '/withdrawalRecord',
        name: 'withdrawalRecord',
        component: () => import('@/pages/withdraw/withdrawalRecord.vue'),        
        meta: {
          title: 'Withdraw Record'
        }
      },
      {
        path: '/withdrawal-card',
        name: 'withdraw card',
        component: () => import('@/pages/withdraw/withdrawalCardManagement.vue'),        
        meta: {
          title: 'Withdrawal'
        }
      },
      
      {
        path: 'promotion/activity',
        name: 'promotion-activity',
        component: () => import('@/pages/Promotion/activity/index.vue'),  
        meta: {
          title: 'Activity'
        }
      },
      {
        path: 'promotion/rebates',
        name: 'promotion-rebates',
        component: () => import('@/pages/Promotion/rebates/Index.vue'),  
        meta: {
          title: 'Rebates'
        }
      },
      {
        path: 'promotion/vip',
        name: 'promotion-vip',
        component: () => import('@/pages/Promotion/vip/index.vue'),  
        meta: {
          title: 'VIP'
        }
      },
      {
        path: 'promotion/history',
        name: 'promotion-history',
        component: () => import('@/pages/Promotion/history/index.vue'),  
        meta: {
          title: 'History'
        }
      },
      {
        path: 'promotion/cover',
        name: 'promotion-cover',
        component: () => import('@/pages/Promotion/cover/index.vue'),  
        meta: {
          title: 'Cover'
        }
      },
      {
        path: '/promotion/activity/recharge',
        name: 'rechargeActivity',
        component: () => import('@/pages/Promotion/activity/rechargeActivity.vue'),        
        meta: {
          title: 'Recharge Activity'
        }
      },
      {
        path: '/test12',
        name: 'test12',
        component: () => import('@/pages/pc/son/pc_transaction'),        
        meta: {
          title: 'Recharge Activity'
        }
      },
      {
        path: '/promotion/activity/invitation-activity',
        name: 'invitationActivity',
        component: () => import('@/pages/Promotion/activity/invitationActivity.vue'),        
        meta: {
          title: 'Invitation Activity'
        }
      },

      {
        path: '/promotion/activity/lottery-wheel',
        name: 'lotteryWheel',
        component: () => import('@/pages/Promotion/activity/lotteryWheel.vue'),        
        meta: {
          title: 'Lottery Wheel'
        }
      },
      {
        path: '/promotion/activity/daily-loss-relief-fund',
        name: 'dailyLossReliefFund',
        component: () => import('@/pages/Promotion/activity/dailyLossReliefFund.vue'),        
        meta: {
          title: 'Daily Loss Relief Fund'
        }
      },
      {
        path: '/promotion/activity/recharge-rebate',
        name: 'rechargeRebateActivity',
        component: () => import('@/pages/Promotion/activity/rechargeRebateActivity.vue'),        
        meta: {
          title: 'Recharge Rebate Activity'
        }
      },
      {
        path: '/information-center/support',
        name: 'information-center',
        component: () => import('@/pages/InformationCenter/Index.vue'),
        meta: {
          title: 'Information Center - Support'
        }
      },
      {
        path: '/information-center/notification',
        name: 'information-center-notification',
        component: () => import('@/pages/InformationCenter/Notification.vue'),
        meta: {
          title: 'Information Center - Notification'
        }
      },
      {
        path: '/information-center/announcement',
        name: 'information-center-announcement',
        component: () => import('@/pages/InformationCenter/Announcement.vue'),
        meta: {
          title: 'Information Center - Announcement'
        }
      },
      {
        path: '/agency-center/invite',
        name: 'invite',
        component: () => import('@/pages/agencyCenter/invite/Index.vue'),
        meta: {
          title: 'Invite'
        }
      },
      {
        path: '/agency-center/agent',
        name: 'agent',
        component: () => import('@/pages/agencyCenter/agent/Index.vue'),        
        meta: {
          title: 'Agent'
        }
      },
      {
        path: '/agency-center/invitation-record',
        name: 'invitationRecord',
        component: () => import('@/pages/agencyCenter/invitationRecord/Index.vue'),        
        meta: {
          title: 'InvitationRecord'
        }
      },
      {
        path: '/agency-center/reward',
        name: 'reward',
        component: () => import('@/pages/agencyCenter/reward/Index.vue'),        
        meta: {
          title: 'Reward'
        }
      },
      {
        path: '/agency-center/agency-mechanism',
        name: 'agencyMechanism',
        component: () => import('@/pages/agencyCenter/agencyMechanism/Index.vue'),        
        meta: {
          title: 'AgencyMechanism'
        }
      },
      {
        path: '/agency-center/register-subordinates',
        name: 'registerSubordinates',
        component: () => import('@/pages/agencyCenter/registerSubordinates/Index.vue'),        
        meta: {
          title: 'RegisterSubordinates'
        }
      },
      {
        path: '/order-center',
        name: 'order-center',
        component: () => import('@/pages/OrderCenter/Index.vue'),
        meta: {
          title: 'Order Center - Details'
        }
      },
      {
        path: '/order-center/fee',
        name: 'order-center-fee',
        component: () => import('@/pages/OrderCenter/Fee.vue'),
        meta: {
          title: 'Order Center - Fee'
        }
      },
      {
        path: '/order-center/association',
        name: 'order-center-association',
        component: () => import('@/pages/OrderCenter/Association.vue'),
        meta: {
          title: 'Order Center - Association'
        }
      },
      {
        path: '/security-center',
        name: 'order-center-association',
        component: () => import('@/pages/securityCenter/index.vue'),        
        meta: {
          title: 'Order Center Association'
        }
      },
      {
        path: '/security-center/verify-password',
        name: 'order-center-association',
        component: () => import('@/pages/securityCenter/verifyPassword.vue'),        
        meta: {
          title: 'Order Center Association'
        }
      },
      {
        path: '/security-center/bind-email',
        name: 'order-center-association',
        component: () => import('@/pages/securityCenter/bindEmail.vue'),        
        meta: {
          title: 'Order Center Association'
        }
      },
      {
        path: '/security-center/change-password',
        name: 'order-center-association',
        component: () => import('@/pages/securityCenter/changePassword.vue'),        
        meta: {
          title: 'Order Center Association'
        }
      },
    ]
  },
  {
    path: '/gameInfo',
    name: 'gameInfo',
    component: () => import('@/pages/newGame/newGameSon/gameInfo.vue'),
    meta: {
      title: '游戏中转'
    },
  },
  {
    path: '/cztx',
    name: 'cztx',
    component: () => import('@/pages/pc/son/pc_transaction.vue'),
    meta: {
      title: '123'
    },
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('../components/gameRecord.vue')
  },
  {
    path: '/download',
    name: 'download',
    component: () => import('../pages/download/downloadApp.vue')
  }
]
const routers = new Router({
  mode: 'history',
  routes: route
})

routers.beforeEach((to, from, next) => {
  next();
  window.scrollTo(0, 0);
});


export default routers



// WEBPACK FOOTER //
// ./src/router/index.js